import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_5 = {
  key: 1,
  class: "btn btn-outline-secondary",
  style: {"padding":"0.7em 2em","cursor":"default"},
  disabled: "",
  title: "You cannot edit a submitted plan"
}
const _hoisted_6 = { class: "toolbar" }
const _hoisted_7 = { class: "dropdown d-inline mr-2" }
const _hoisted_8 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = { class: "table table-bordered table-hover" }
const _hoisted_11 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_12 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "btn btn-outline-secondary",
  disabled: "",
  style: {"cursor":"default"},
  title: "You cannot modify a submitted plan"
}

import { computed, shallowReactive, onMounted, watch, ref } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { toPercentageString, toStringSmartly } from '@common/Common'
    import { guid } from '@common/Guid'
    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import Navigation from '@common/Navigation.vue'
    import CapexItemEditor from '@Quest/Capex/Components/CapexItemEditor.vue'
    import ProjectNavigation from '@Quest/ProjectPlans/Components/ProjectNavigation.vue'
    import ProjectContextHeader from '@Quest/ProjectPlans/Components/ProjectContextHeader.vue'
    import { DepreciationMethodType } from '@Quest/Capex/types'
    import { useProjectCapexQueryV1 } from '@Quest/ProjectPlans/queries-vue-composables'
    import { useCreateProjectCapexItemCommandV1, useUpdateProjectCapexItemCommandV1, useDeleteProjectCapexItemCommandV1 } from '@Quest/ProjectPlans/commands-vue-composables'
    import type { ProjectCapexItemReadModel, ProjectPlanCapexReadModel } from '@Quest/ProjectPlans/readmodels'
    import { CapexItemEditorFormSubmitEventPayload, CapexItemEditorViewModel } from '@Quest/Capex/Components/CapexItemEditor'
    import type { CurrencyDenomination } from '@common/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectCapexPage',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()
    const workspaceId = computed(() => Number.parseInt(route.params.workspaceId as string))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const projectId = computed(() => String(route.params.projectId ?? ''))

    const projectPlanId = computed<string | null>(() => rm.value?.ProjectPlanId ?? null)
    const denomination = computed<CurrencyDenomination | null>(() => rm.value?.Denomination ?? null)

    const projectName = computed(() => rm.value?.ProjectName ?? '')
    const projectPlanName = computed<string>(() => rm.value?.ProjectPlanName ?? '')
    const activePlanId = computed<string | null>(() => rm.value?.ActiveProjectPlanId ?? null)
        
    const portfolioId = computed(() => rm.value?.PortfolioId ?? '')
    const userId = computed(() => rm.value?.UserId ?? 0)
    const isWorkspaceMember = computed(() => rm.value?.IsWorkspaceMember ?? false)
    const isProjectOwner = computed(() => rm.value?.IsProjectOwner ?? false)
    const isSubmitted = computed(() => rm.value?.IsSubmitted ?? false)
    

    const {
        runProjectCapexQueryV1,
        modelProjectCapexQueryV1
    } = useProjectCapexQueryV1(workspaceId, tchProjectId, projectId, projectPlanId, denomination)

    const rm = ref<ProjectPlanCapexReadModel | null>(null)

    const capexItemEditor = shallowReactive(new CapexItemEditorViewModel())

    const {
        invokeCreateProjectCapexItemCommandV1,
        onSucceedCreateProjectCapexItemCommandV1
    } = useCreateProjectCapexItemCommandV1(userId, workspaceId, portfolioId, projectId, projectPlanId)

    const {
        invokeUpdateProjectCapexItemCommandV1,
        onSucceedUpdateProjectCapexItemCommandV1
    } = useUpdateProjectCapexItemCommandV1(userId, workspaceId, portfolioId, projectId, projectPlanId)

    const {
        invokeDeleteProjectCapexItemCommandV1,
        onSucceedDeleteProjectCapexItemCommandV1,
    } = useDeleteProjectCapexItemCommandV1(userId, workspaceId, portfolioId, projectId, projectPlanId)

    function fmtNum(val: number | null)
    {
        return toStringSmartly(val)
    }

    function fmtPct(val: number | null)
    {
        return toPercentageString(val)
    }


    function showCapexCreator()
    {
        if (!rm.value) return
        capexItemEditor.showCreator(rm.value.CurrencyLabel, rm.value.CapexAccounts)
    }

    function showCapexEditor(c: ProjectCapexItemReadModel)
    {
        if (!rm.value) return

        capexItemEditor.showEditor(
            c.Id,
            c.Name,
            c.CapexAccountId,
            c.Cost,
            c.UsefulLifeInYears,
            c.AcquisitionMonthIndex,
            c.SalvageValue,
            rm.value.CurrencyLabel,
            rm.value.CapexAccounts
        )
    }

    function handleCapexItemEditorFormSubmit(e: CapexItemEditorFormSubmitEventPayload)
    {
        if (!rm.value) return

        const payload = {
            itemId: e.id ?? guid(),
            capexAccountId: e.accountId,
            name: e.name,
            cost: e.cost,
            acquisitionMonthIndex: e.acquisitionMonthIndex,
            salvageValue: e.salvageValue,
            usefulLifeInYears: e.usefulLifeInYears,
            depreciationMethod: DepreciationMethodType.StraightLine,
            denomination: rm.value.Denomination
        }

        if (e.id == null)
        {
            invokeCreateProjectCapexItemCommandV1(payload)
        }
        else
        {
            invokeUpdateProjectCapexItemCommandV1(payload)
        }
    }

    function handleDeleteProjectCapexItemCommand(capex: ProjectCapexItemReadModel)
    {
        if (!rm.value) return

        if (confirm('Are you sure?'))
        {
            invokeDeleteProjectCapexItemCommandV1({ itemId: capex.Id })
        }
    }

    function setDenomination(newDenomination: CurrencyDenomination)
    {
        const query = { ...route.query }

        query.denomination = newDenomination

        router.replace({
            params: { ...route.params },
            query
        })

        runProjectCapexQueryV1(
        {
            Denomination: newDenomination,
        })
    }


    onMounted(() =>
    {
        document.title = 'Capex | TransparentChoice'

        runProjectCapexQueryV1({
            ProjectPlanId: route.params.planId ? String(route.params.planId) : null,
            Denomination: route.query.denomination as CurrencyDenomination ?? null
        })
    })

    watch(() => route.params.planId, () => 
    {
        runProjectCapexQueryV1({
            ProjectPlanId: route.params.planId as string | null
        })
    })

    watch(modelProjectCapexQueryV1, (current) =>
    {
        if (current?.RedirectUrl)
        {
            window.location.replace(current.RedirectUrl)
        }

        if (current)
        {
            rm.value = current
        }
    })


    onSucceedCreateProjectCapexItemCommandV1(() =>
    {
        capexItemEditor.close()
        runProjectCapexQueryV1()
    })

    onSucceedUpdateProjectCapexItemCommandV1(() =>
    {
        capexItemEditor.close()
        runProjectCapexQueryV1()
    })

    onSucceedDeleteProjectCapexItemCommandV1(() =>
    {
        runProjectCapexQueryV1()
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CapexItemEditor, {
      viewModel: _unref(capexItemEditor),
      onFormSubmit: handleCapexItemEditorFormSubmit
    }, null, 8 /* PROPS */, ["viewModel"]),
    (isWorkspaceMember.value)
      ? (_openBlock(), _createBlock(PortfolioNavigation, {
          key: 0,
          workspaceId: workspaceId.value,
          projectId: tchProjectId.value
        }, null, 8 /* PROPS */, ["workspaceId", "projectId"]))
      : (isProjectOwner.value)
        ? (_openBlock(), _createBlock(Navigation, { key: 1 }))
        : _createCommentVNode("v-if", true),
    (rm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(ProjectContextHeader, {
                projectName: projectName.value,
                planId: projectPlanId.value,
                planName: projectPlanName.value,
                activePlanId: activePlanId.value
              }, null, 8 /* PROPS */, ["projectName", "planId", "planName", "activePlanId"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createCommentVNode(" When NOT submitted "),
              (!isSubmitted.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-success",
                    style: {"padding":"0.7em 2em"},
                    onClick: showCapexCreator
                  }, " Create "))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" When submitted "),
              (isSubmitted.value)
                ? (_openBlock(), _createElementBlock("button", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("i", { class: "fas fa-lock mr-2" }, null, -1 /* CACHED */),
                    _createTextVNode(" Submitted ", -1 /* CACHED */)
                  ]))]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createVNode(ProjectNavigation, {
            ActivePage: "capex",
            class: "mt-4 mb-4",
            workspaceId: workspaceId.value,
            tchProjectId: tchProjectId.value,
            projectId: projectId.value,
            planId: projectPlanId.value
          }, null, 8 /* PROPS */, ["workspaceId", "tchProjectId", "projectId", "planId"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", _hoisted_8, _toDisplayString(denomination.value) + "s ", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (setDenomination('Million')))
                  }, "Millions"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (setDenomination('Thousand')))
                  }, "Thousands"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (setDenomination('Unit')))
                  }, "Units")
                ])
              ])
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", null, null, -1 /* CACHED */))
          ]),
          _createElementVNode("table", _hoisted_10, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("th", null, "Capex", -1 /* CACHED */)),
                _cache[6] || (_cache[6] = _createElementVNode("th", null, "Account", -1 /* CACHED */)),
                _createElementVNode("th", null, "Cost (" + _toDisplayString(rm.value.CurrencyLabel) + ")", 1 /* TEXT */),
                _createElementVNode("th", null, "Salvage value (" + _toDisplayString(rm.value.CurrencyLabel) + ")", 1 /* TEXT */),
                _cache[7] || (_cache[7] = _createElementVNode("th", null, "Useful life (years)", -1 /* CACHED */)),
                _createElementVNode("th", null, "Annual expense (" + _toDisplayString(rm.value.CurrencyLabel) + ")", 1 /* TEXT */),
                _cache[8] || (_cache[8] = _createElementVNode("th", { style: {"width":"150px"} }, null, -1 /* CACHED */))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.CapexItems, (c) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(c.Name), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(c.CapexAccountName), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(fmtNum(c.Cost)), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(fmtNum(c.SalvageValue)), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(c.UsefulLifeInYears), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(fmtNum(c.AnnualExpense)), 1 /* TEXT */),
                  _createElementVNode("td", null, [
                    _createCommentVNode(" If NOT submitted: show actions dropdown "),
                    (!isSubmitted.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _cache[9] || (_cache[9] = _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-secondary dropdown-toggle",
                            "data-toggle": "dropdown"
                          }, " Actions ", -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (showCapexEditor(c))
                            }, "Edit", 8 /* PROPS */, _hoisted_13),
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (handleDeleteProjectCapexItemCommand(c))
                            }, "Delete", 8 /* PROPS */, _hoisted_14)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" If submitted: show disabled button with lock icon "),
                    (isSubmitted.value)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_15, [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("i", { class: "fas fa-lock mr-2" }, null, -1 /* CACHED */),
                          _createTextVNode(" Submitted ", -1 /* CACHED */)
                        ]))]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})